import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { GridApi } from 'ag-grid-community';
import { Subject, SubscriptionLike } from 'rxjs';
import { ApidataRequestService } from 'src/app/services/apidata-request.service';
import { MessageBoxComponent } from '../../message-box/message-box.component';
import { PreviewActivityLogComponent } from './preview-activity-log/preview-activity-log.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common.service';
import { DateObject } from 'src/app/models/common';

@Component({
  selector: 'app-activity-log',
  templateUrl: './activity-log.component.html',
  styleUrls: ['./activity-log.component.scss']
})
export class ActivityLogComponent implements OnInit {

  subGetData: SubscriptionLike;
  subSearchRecords: SubscriptionLike;
  operations;
  tempoperation;
  selectedRow;
  IsAdvanceSearch: boolean = true;
  gridApi: GridApi;
  rowData: any = [];
  columnDefs: any;
  ActivityLogForm: UntypedFormGroup;
  action: Subject<any> = new Subject();
  log_data: any
  OrgUsersList: any[];
  ApplicationIdsList: any[];
  filteredApplicationIds: any[];
  auditActivityLogSearch = new IEGAuditActivityLogSearch();
  clonedauditActivityLogSearch: IEGAuditActivityLogSearch = {
    StartDateO: new DateObject,
    EndDateO: new DateObject
  };
  Categorygrayout: boolean = true;
  GrandTypeList: Array<any> = [];
  IsGrandType: boolean = false;
  IsOnlyGrandType: boolean = false;
  maxDate :Date = new Date() ; 
  minDate :Date = new Date();
  currentDate : Date = new Date(); 
  myDate = new Date();
  yesterday = new Date(this.myDate.setDate(new Date().getDate() + 1));
  year = this.yesterday.getFullYear();
  moth = this.yesterday.getMonth() + 1;
  Day = this.yesterday.getDate();

  @Input() screencode: string;
  public ModuleID: string;
  //SDates: any;
  //EDates: any;

  constructor(public modalRef: NgbActiveModal,
    private modalService: NgbModal,
    public apiService: ApidataRequestService,
    public commonService:CommonService
  ) { }

  ngOnInit(): void {
    this.IsAdvanceSearch = true;
    this.ModuleID = this.screencode;
    this.gridHeaderandActionSettings();
    this.ActivityLogFormControls();
    if (this.screencode == "grants") {
      this.IsGrandType = true;
      this.IsOnlyGrandType = false;
      this.GetGrantTypesActivityLog();
    }
    else {
      this.GrandTypeList = [];
      this.IsGrandType = false;
      this.IsOnlyGrandType = false;
    }
    this.GetOrgUsersList();
    this.GetApplicationIdsList(this.ModuleID);
    this.Categorygrayout = true;
  }

  toggleCase() {
    this.IsAdvanceSearch = !this.IsAdvanceSearch;
  }

  ActivityLogFormControls() {
    this.ActivityLogForm = new UntypedFormGroup({
      GrantType: new UntypedFormControl(""),
      ApplicationID: new UntypedFormControl(""),
      UserName: new UntypedFormControl("", [Validators.required]),
      StartDate: new UntypedFormControl(null, [Validators.required]),
      EndDate: new UntypedFormControl(null, [Validators.required])
    })
  }

  gridHeaderandActionSettings() {
    this.columnDefs = [
      { headerName: "Activities #", headerTooltip: "Activities #", field: 'revision_num', sortable: false, tooltipField: "revision_num" },
      { headerName: "Username", headerTooltip: "Username", field: 'Username', sortable: false, tooltipField: "Username" },
      { headerName: "Application ID", headerTooltip: "Application ID", field: 'ApplicationID', sortable: false, tooltipField: "ApplicationID" },
      { headerName: "Performed on Date and Time", headerTooltip: "Performed on Date and Time", field: 'PerformedonDateTime', sortable: false, tooltipField: "PerformedonDateTime" }
    ];
    this.tempoperation = [];
    this.tempoperation.push({
      "name": "View",
      "id": "View"
    });
    this.operations = this.tempoperation.map(operation => {
      return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });
  }

  GetOrgUsersList() {
    this.subGetData = this.apiService.getData("api/IEGAuditActivityLogs/GetAllOrgUsersList?ModuleName=" + this.ModuleID).subscribe(
      (res) => {
        if (res["Status"]) {
          this.OrgUsersList = res["Data"];
        } else {
          this.OrgUsersList = [];
        }
      },

      (err) => {
        //console.error(err);
      }
    );
  }


  GetGrantTypesActivityLog() {
    this.subGetData = this.apiService.getData("api/IEGAuditActivityLogs/GetGrantTypesActivityLog").subscribe(
      (res) => {

        if (res["Status"]) {
          this.GrandTypeList = res["Data"];
          if (this.GrandTypeList.length > 1) {
            this.IsOnlyGrandType = false;
            this.ActivityLogForm.controls["GrantType"].setValue("All");
          }
          else {
            this.ActivityLogForm.controls["GrantType"].setValue(this.GrandTypeList[0].value);
            this.IsOnlyGrandType = true;
          }

        } else {
          this.GrandTypeList = [];
          this.IsOnlyGrandType = false;
        }
      },

      (err) => {
        //console.error(err);
      }
    );
  }

  GetApplicationIdsList(ModuleID: string) {
    this.subGetData = this.apiService.getData("api/IEGAuditActivityLogs/GetApplicationIdsList?ModuleName=" + this.ModuleID).subscribe(
      (res) => {
        if (res["Status"]) {
          this.ApplicationIdsList = res["Data"];
        } else {
          this.ApplicationIdsList = [];
        }
      },

      (err) => {
        // console.error(err);
      }
    );
  }

  addSuggestionList(event) {
    let AppId = event.target.value;
    let AppIds: any[] = [];// this.ActivityLogForm.controls['ApplicationID']?.value;
    if (AppId != null && AppId != "" && AppId != undefined) {
      if (AppIds == null || AppIds.length == 0)
        AppIds.push({ value: AppId, label: AppId });
      else {
        let fAppId = AppIds.find(x => x.label.toLowerCase() == AppId.toLowerCase());
        if (fAppId == null || fAppId == undefined)
          AppIds.push({ value: AppId, label: AppId });
      }
    }
  }

  filterApplicationId(event) {
    let filtered: any[] = []; let query = event.query;
    for (let i = 0; i < this.ApplicationIdsList.length; i++) {
      let ApplicationId = this.ApplicationIdsList[i];
      if (ApplicationId.label.toLowerCase().indexOf(query.toLowerCase()) == 0) { filtered.push(ApplicationId); }
    }
    this.filteredApplicationIds = filtered;
  }

  change(event) {
    let val = this.filteredApplicationIds?.find(x => x.label == event.target.label);
    if (val == null || val == undefined) {
      this.ActivityLogForm.controls['ApplicationID'].setValue("");
    }
    else{
      this.ActivityLogForm.controls['ApplicationID'].setValue(val.label);
    }
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }
  Clear() {
    this.ActivityLogForm.patchValue({
      GrantType: "All",
      ApplicationID: "",
      UserName: "",
      StartDate: null,
      EndDate: null
    });
    this.Categorygrayout = true;
    this.rowData = [];
    //this.SDates = "";
    //this.EDates = "";
    this.maxDate = new Date();
  }


  Search() {
    if (this.validateForm()) {
      this.auditActivityLogSearch = new IEGAuditActivityLogSearch();
      this.auditActivityLogSearch.ModuleId = this.ModuleID;
      let Appdata = this.ActivityLogForm.controls["ApplicationID"].value;
      var appId = (Appdata.label == null || Appdata.label == undefined) ? Appdata : Appdata.label;
      this.auditActivityLogSearch.ApplicationId = appId;
      this.auditActivityLogSearch.GrantType = this.ActivityLogForm.controls["GrantType"].value;
      this.auditActivityLogSearch.UserName = this.ActivityLogForm.controls["UserName"].value;
      this.auditActivityLogSearch.StartDate = this.ActivityLogForm.controls["StartDate"].value;
      this.auditActivityLogSearch.EndDate = this.ActivityLogForm.controls["EndDate"].value;
      this.auditActivityLogSearch.EndDateO = this.Full_End_Date;
      this.auditActivityLogSearch.StartDateO = this.Full_Start_Date;
      this.clonedauditActivityLogSearch = JSON.parse(JSON.stringify(this.auditActivityLogSearch));
      this.auditActivityLogSearch.ModuleId = this.clonedauditActivityLogSearch.ModuleId;
      this.subSearchRecords = this.apiService.getDataPost("api/IEGAuditActivityLogs/GetIEGActivityLogSearch", this.auditActivityLogSearch).subscribe(result => {
        if (result.Status && result.Data.length > 0) {
          this.rowData = result.Data;
        } else {
          this.rowData = [];
        }
      });
    }
  }
  isStartDateModified: boolean = false;
  isEndDateModified: boolean = false;
  Full_Start_Date: DateObject;
  Full_End_Date: DateObject;

  startDateSelect(event) {
    this.isStartDateModified = true
    this.Full_Start_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isStartDateModified
    }
    this.minDate = new Date(event);
  }
  endDateSelect(event) {
    this.isEndDateModified = true;
    this.Full_End_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 23,
      Minutes: 59,
      Seconds: 59,
      IsEndDate: true,
      HasValue: true,
      IsDateModified: this.isEndDateModified
    }
    this.maxDate = new Date(event);
  }
  validateForm() {
    var err: any = [];
    if (!this.ActivityLogForm.valid) {
      if (this.screencode == "grants") {
        if (
          !this.ActivityLogForm.controls["ApplicationID"].value &&
          !this.ActivityLogForm.controls["UserName"].value &&
          !this.ActivityLogForm.controls["StartDate"].value &&
          !this.ActivityLogForm.controls["EndDate"].value
        ) {
          err.push("Please enter at least one criteria to perform search");
          this.commonService.ValidationBanner(err);
          //this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: err } } });
          return false;
        }
      }
      if ((this.ActivityLogForm.get('ApplicationID')?.value == null || this.ActivityLogForm.get('ApplicationID')?.value == "")) {
        err.push("Please select application ID");
        this.commonService.ValidationBanner(err);
        // this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: err } } });
        return false;
      }
      if (
        !this.ActivityLogForm.controls["UserName"]?.valid &&
        ((this.ActivityLogForm.controls["StartDate"].value == null &&
          this.ActivityLogForm.controls["EndDate"].value == null) ||
          (this.ActivityLogForm.controls["StartDate"].value == "" &&
            this.ActivityLogForm.controls["EndDate"].value == ""))
      ) {
        err.push("Please select username /date range");
        this.commonService.ValidationBanner(err);
        // this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: err } } });
        return false;
      }

      if (this.ActivityLogForm.controls["StartDate"].value != null) {
        if (this.ActivityLogForm.controls["EndDate"].value == null) {
          err.push("Please select end date");
          this.commonService.ValidationBanner(err);
          //this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: err } } });
          return false;
        }
      }
      if (this.ActivityLogForm.controls["StartDate"].value == null) {
        if (this.ActivityLogForm.controls["EndDate"].value != null) {
          err.push("Please select start date");
          this.commonService.ValidationBanner(err);
          // this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: err } } });
          return false;
        }
      }


      // if (
      //   this.ActivityLogForm.controls["StartDate"].value != null && this.ActivityLogForm.controls["EndDate"].value != null)
      //   {
      //   if (
      //     new Date(this.ActivityLogForm.controls["StartDate"].value) >
      //     new Date(this.ActivityLogForm.controls["EndDate"].value)
      //   ) {
      //     err.push("Start Date should not be greater than End Date");
      //     this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: err } } });
      //     return false;
      //   }
      // }
    }
    return true;
  }


  View() {

    var ApplicationId = this['self'].selectedRow['ApplicationID'];
    var ModuleId = this['self'].clonedauditActivityLogSearch.ModuleId;
    var GrantType = this['self'].clonedauditActivityLogSearch.GrantType;
    let modalRef1 = this.modalService.open(PreviewActivityLogComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-xl right modal-right',
      animation: true
    });
    modalRef1.componentInstance.Content = {
      heading: ApplicationId,
      content: {
        ApplicationId: ApplicationId, ModuleId: ModuleId, GrantType: GrantType
      }
    }

  }

  onRowDoubleClicked(event) {

    var ApplicationId = event.data['ApplicationID'];
    var ModuleId = this.clonedauditActivityLogSearch.ModuleId;
    var GrantType = this.clonedauditActivityLogSearch.GrantType;
    let modalRef1 = this.modalService.open(PreviewActivityLogComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-xl right modal-right',
      animation: true
    });
    modalRef1.componentInstance.Content = {
      heading: ApplicationId,
      content: {
        ApplicationId: ApplicationId, ModuleId: ModuleId, GrantType: GrantType
      }
    }
  }

}
export class IEGAuditActivityLogSearch {
  ModuleId?: string;
  Category?: string;
  ApplicationId?: string;
  UserName?: string;
  StartDate?: string;
  EndDate?: string;
  OrgID?: string;
  cDetails?: string;
  cComp?: string;
  GrantType?: string;
  StartDateO: DateObject;
  EndDateO: DateObject
}
